/**
 * authUiBus.ts
 * ------------
 * Tiny event bus that bridges the axios interceptor (which runs outside the
 * React tree) to a React component. The interceptor emits a modal payload; a
 * single <AuthErrorModal/> mounted at the app root listens and renders it.
 */
export type ModalPayload = {
  title: string;
  message: string;
  correlationId?: string;
  onOk: () => void;
};

type Listener = (p: ModalPayload) => void;

class AuthUiBus {
  private listeners: Listener[] = [];

  onModal(l: Listener): () => void {
    this.listeners.push(l);
    return () => {
      this.listeners = this.listeners.filter((x) => x !== l);
    };
  }

  emitModal(p: ModalPayload): void {
    this.listeners.forEach((l) => l(p));
  }
}

export const authUiBus = new AuthUiBus();
